export class MediaTypes {
    static imagePng = "image/png";
}